/**
 * Loads demo image files from the assets/demo directory.
 * Uses Vite's glob import to get URLs for all demo JPGs.
 */
export async function loadDemoFiles(): Promise<File[]> {
  // Import all demo images as URLs using Vite's glob
  const modules = import.meta.glob('../assets/demo/*.jpg', {
    eager: true,
    query: '?url',
    import: 'default',
  });

  // Fetch each URL and convert to File objects
  const filePromises = Object.entries(modules).map(async ([path, url]) => {
    const response = await fetch(url as string);
    const blob = await response.blob();

    // Extract filename from path
    const filename = path.split('/').pop() || 'demo.jpg';

    return new File([blob], filename, { type: 'image/jpeg' });
  });

  return Promise.all(filePromises);
}
